module.exports = "\n// we use this vertex shader for the post process steps. All we do is copy the uv value and set position appropriately\n\nvarying vec2 f_uv;\nvoid main() {\n    f_uv = uv;\n    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);\n}"


//////////////////
// WEBPACK FOOTER
// ./src/glsl/pass-vert.glsl
// module id = 2
// module chunks = 0